import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import TermsAndConditions from '../PdfViewer/TermsAndConditions';
import './form.css';

const SummaryForm = ({ formData, prevStep, handleSubmit }) => {
  const { t } = useTranslation();

  // const [showBusinessDetails, setShowBusinessDetails] = useState(false);
    const [isAccepted, setAccepted] = useState(false);

  const onSubmit = async () => {
    await handleSubmit(); // to trigger the OTP screen
  };

  // const toggleBusinessDetails = () => {
  //   setShowBusinessDetails(!showBusinessDetails);
  // };

  return (
    <form className="form summary-form">
      <h3 className="form-title">{t("register_summary.your_registration_summary")}</h3>
      <p className="summary-note">{t("register_summary.review_info")}</p>
      <p className="summary-note" style={{color:'var(--red-dark)'}}>{t("register_summary.accept_terms")}</p>

      {/*Split Layout for Personal & Business Information */}

        <div className={`summary-grid ${formData.role === 'PA' ? 'single-column' : ''}`}>
          {/*Left Section: Personal Information */}
          <div className="summary-section personal-info">
            <h4 className="section-title">{t("register_summary.personal_information")}</h4>
            <ul className="summary-list">
              <li className="summary-item">
                <span className="label">{t("register_summary.personal_email")}:</span> 
                <span className="value">{formData.email}</span>
              </li>
              <li className="summary-item">
                <span className="label">{t("register_summary.your_first_name")}:</span> 
                <span className="value">{formData.firstName}</span>
              </li>
              <li className="summary-item">
                <span className="label">{t("register_summary.your_last_name")}:</span> 
                <span className="value">{formData.lastName}</span>
              </li>
              <li className="summary-item">
                <span className="label">{t("register_summary.personal_phone")}:</span> 
                <span className="value">{formData.phone}</span>
              </li>
            </ul>
          </div>

          {/*Right Section: Business Information (Only for CA) */}
          {(formData.role === 'CA' || formData.role === 'CO') &&  (
            <div className="summary-section business-info">
              <h4 className="section-title">{t("register_summary.business_information")}</h4>
              <ul className="summary-list">
                <li className="summary-item">
                  <span className="label">{t("register_summary.business_name")}:</span> 
                  <span className="value">{formData.business_name}</span>
                </li>
                <li className="summary-item">
                  <span className="label">{t("register_summary.business_ein")}:</span> 
                  <span className="value">{formData.business_number}</span>
                </li>
                {/* <li className="summary-item">
                  <span className="label">{t("register_summary.registry_id")}:</span> 
                  <span className="value">{formData.registry_id}</span>
                </li> */}
                <li className="summary-item">
                  <span className="label">{t("register_summary.business_operating_as")}:</span> 
                  <span className="value">{formData.business_operating_as}</span>
                </li>
                <li className="summary-item">
                  <span className="label">{t("register_summary.business_phone")}:</span> 
                  <span className="value">{formData.business_phone}</span>
                </li>
                <li className="summary-item">
                  <span className="label">{t("register_summary.business_email")}:</span> 
                  <span className="value">{formData.business_email}</span>
                </li>
              </ul>
            </div>
          )}
        </div>
        
        {/* Top Summary Block for Max Practitioners */}
{(formData.role === 'CA' || formData.role === 'CO') && (
  <div className="summary-highlight max-practitioners-info">
    <strong>{t("register_summary.max_practitioners_selected")}:</strong>{' '}
    {formData.max_practitioners} {t("register_summary.practitioners_label")}
  </div>
)}

        {/*Terms & Conditions Section */}
        <div className="terms-container">
          <TermsAndConditions pdfUrl="/Plus_Life_Terms_of_Service.pdf" onAccept={setAccepted} />
        </div>


      {/*Footer Section - Previous & Submit Buttons */}
        <div className="form-footer">
          <button className="btn btn-secondary" type="button" onClick={prevStep}>
            {t("register_summary.previous")}
          </button>
          <button className="btn btn-primary" type="button" onClick={onSubmit} disabled={!isAccepted}>
            {t("register_summary.submit")}
          </button>
        </div>
    </form>
);

};

export default SummaryForm;
